export const formatRuntimeDuration = (valueInMinutes: number): string => {
  if (valueInMinutes === 0) return "0m"

  const days = Math.floor(valueInMinutes / (24 * 60))
  const hours = Math.floor((valueInMinutes % (24 * 60)) / 60)
  const minutes = Math.floor(valueInMinutes % 60)

  const parts: string[] = []
  if (days > 0) parts.push(`${days}d`)
  if (hours > 0) parts.push(`${hours}h`)
  if (minutes > 0) parts.push(`${minutes}m`)

  return parts.join(" ")
}
